






















import { Component, Vue, Watch } from "vue-property-decorator";
import { ClientRedirectUri } from "../../../../types/client";
import { SaveMixin } from "@/services/mixins/saveMixin";
import { required, maxLength } from "vuelidate/lib/validators";
import { HttpService } from "../../../../services/api/httpService";
import { isUrl } from "@/services/customValidator/customValidators";
@Component({
  mixins: [SaveMixin],
  validations: {
    clientRedirectUri: {
      redirectUri: { required, maxLength: maxLength(250), isUrl }
    }
  }
})
export default class ClientRedirectUriSave extends Vue {
  clientRedirectUri = new ClientRedirectUri();
  httpService = new HttpService<ClientRedirectUri>();
  showData = false;
  backRoute = {
    name: "clientDashboard",
    id: ""
  };

  async created() {
    if (this.$route.params.redirectUriId) {
      const response = await this.httpService.getItem(
        `clients/${this.$route.params.id}/redirect-uris/${this.$route.params.redirectUriId}`
      );

      this.clientRedirectUri = response.data || new ClientRedirectUri();
    }
    this.clientRedirectUri.clientId = Number(this.$route.params.id);
    this.backRoute.id = this.$route.params.id;
    this.showData = true;
  }

  async save() {
    this.$store.commit("SAVE", false);
    this.$v.$touch();

    if (!this.$v.$invalid) {
      let save = "";
      this.clientRedirectUri.id
        ? await this.httpService.putItem(
            `clients/${this.clientRedirectUri.clientId}/redirect-uris/${this.clientRedirectUri.id}`,
            this.clientRedirectUri
          )
        : await this.httpService.postItem(
            `clients/${this.clientRedirectUri.clientId}/redirect-uris`,
            this.clientRedirectUri
          );
      this.$notification.success("Redirect Uri Successfully Saved");
      this.$router.push(this.backRoute);
      this.$store.dispatch("SET_DIRTY", false);
    }
  }
}
